import { Component, ElementRef, EventEmitter, Input, OnInit, Output, TemplateRef, ViewChild } from '@angular/core';
import { UntypedFormArray, UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { Constant } from 'src/app/constants/constant';
import { Order, SalesFlatOrderAddress, SalesFlatOrderItem, SalesFlatOrderPayment, SalesFlatOrderStatusHistory } from 'src/app/models/order';
import { CommonService } from 'src/app/services/common.service';
import { OrderService } from 'src/app/services/order.service';
import { UserService } from 'src/app/services/user.service';
import { download } from 'src/app/shared/utils/calsoft-validators';

import { environment } from 'src/environments/environment';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Platform } from '@angular/cdk/platform';
import { TrackingService } from 'src/app/services/tracking.service';
import { TrackShipmentComponent } from './track-shipment/track-shipment.component';
import { ConfigServiceService } from 'src/app/services/config-service.service';
import { SalesOrderStatusService } from 'src/app/services/salesorderstatus.service';
import { jsPDF } from 'jspdf';
import html2canvas from 'html2canvas';

declare var device;
@Component({
  selector: 'app-order',
  templateUrl: './order.component.html',
  styleUrls: ['./order.component.scss']
})
export class OrderComponent implements OnInit {

  deliveryAddressLabel: string = "Delivery Address";

  public serverPath7 = environment.commonImageApi + "catalog/product/";

  private serverPath = environment.ImageAPI;

  public server_Path = environment.serverAPI2 + "/api/core/download?fileName=logo/logo.png";

  public server_Path1 = environment.serverAPI2 + "/api/core/download?fileName=logo/secondaryLogo.png";

  public serverPath12 = environment.commonImageApi + "categoryPageImageLayout/";


  orderItem: Object;
  orderList: Order;
  firstFormGroup: UntypedFormGroup;
  @Output() getTotal: EventEmitter<any> = new EventEmitter<any>();
  visiblePrescriptionLayout: boolean;
  showGst: any = 0;
  cancelEnabled: any = 0;
  status: string;
  taxName: any;
  priceDetailType: any = 0;
  otpText: any;
  otpShowType: any;
  showSecondaryStatus: any;
  secondaryStatus: any;

  storeName: any;
  streetAddress: any;
  streetAddressLine2: any;
  vatNumber: any;
  hsnNumber: any;
  pancardNo: any;
  imageUrl: any;
  imageUrl1: any;
  invoiceTemplateId: any;
  enableGst: any;
  zipPostCode: any;
  email: any;
  storePhoneNumber: any;
  data: any;
  order: any;
  init: boolean = false;
  initCore: boolean = false;
  btndownload: string = 'Download';
  categoryPageImageLayout: any;
  deliveryPerson: any;
  address: any;
  warehouseLatitude: any;
  warehouseLongitude: any;

  // @Input() data:any;
  // @Input() order:any;


  constructor(
    private orderService: OrderService,
    public formBuilder: UntypedFormBuilder,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    public dialog: MatDialog,
    public userService: UserService,
    private configService: ConfigServiceService,
    private commonService: CommonService,
    private titleService: Title,
    public snackBar: MatSnackBar,
    public platform: Platform,
    public trackingService: TrackingService,
    private orderstatusService: SalesOrderStatusService
  ) { }
  textCancel: string;
  additionalPaymentText: any;
  codPaymentCharge: any;
  ngOnInit() {
    this.titleService.setTitle("Order information |" + Constant.siteName);
    this.textCancel = 'OK';
    this.getOrderById();
    this.orderViewForm();
    this.getConfigData();


    if (this.categoryPageImageLayout == undefined) {
      this.categoryPageImageLayout = 'assets/images/products/placeholder.jpg';
    } else {
      this.categoryPageImageLayout = this.serverPath12 + this.data['categoryPageImageLayout']
    }

    let DATA: any = document.getElementById('htmlData');
    DATA.style.display = 'none';

  }

  getConfigData() {
    this.configService.getConfigData()
      .subscribe(
        data => {

          this.showGst = data['showGstCartPage'];
          this.showGst = data['showGstCartPage'];
          this.cancelEnabled = data['cancelEnabled'];
          this.additionalPaymentText = data['additionalPaymentText'];
          this.codPaymentCharge = data['codPaymentCharge'];
          this.taxName = data['taxName'];
          this.priceDetailType = data['priceDetailType'];
          this.otpText = data['otpText'];
          this.otpShowType = data['otpShowType'];
          this.showSecondaryStatus = data['showSecondaryStatusOrders'];

          this.data = data;

          this.initCore = true;
          this.storeName = data['storeName'];
          this.streetAddress = data['streetAddress'];
          this.streetAddressLine2 = data['streetAddressLine2'];
          this.vatNumber = data['vatNumber'];
          this.hsnNumber = data['hsnNumber'];
          this.pancardNo = data['pancardNo'];
          //this.imageUrl=data['imageUrl'];            
          this.enableGst = data['enableGst'];
          this.zipPostCode = data['zipPostCode'];
          this.email = data['email'];
          this.storePhoneNumber = data['storePhoneNumber'];
          this.imageUrl = this.server_Path;
          this.imageUrl1 = this.server_Path1;
          this.invoiceTemplateId = data['invoiceTemplateId'];
          this.categoryPageImageLayout = this.data['categoryPageImageLayout'];
          //  sessionStorage.setItem(COUNTRYCODE, data['currencyBase']);


        }, error => {

        }
      );
  }

  orderViewForm() {
    this.firstFormGroup = this.formBuilder.group({
      operationType: [''],
      entityId: [''],
      state: [''],
      status: [''],
      newStatus: [''],
      couponCode: [''],
      protectCode: [''],
      shippingDescription: [''],
      isVirtual: [''],
      storeId: [''],
      customerId: [''],
      baseDiscountAmount: [''],
      baseDiscountCancelled: [''],
      baseDiscountInvoice: [''],
      baseShippingRefunded: [''],
      baseGrandTotal: [''],
      baseShippingTaxAmount: [''],
      baseShippingTaxRefunded: [''],
      baseSubtotal: [''],
      baseSubtotalCancelled: [''],
      baseSubtotalInvoiced: [''],
      baseTaxAmount: [''],
      baseTaxCancelled: [''],
      baseTaxInvoiced: [''],
      baseTaxRefunded: [''],
      baseToGlobalRate: [''],
      baseToOrderRate: [''],
      baseTotalCancelled: [''],
      baseTotalInvoiced: [''],
      baseTotalInvoicedCost: [''],
      baseTotalOfflineRefunded: [''],
      baseTotalOnlineRefunded: [''],
      baseTotalPaid: [''],
      baseTotalQtyOrdered: [''],
      baseTotalRefunded: [''],
      discountAmount: [''],
      discountCancelled: [''],
      discountInvoiced: [''],
      discountRefunded: [''],
      grandTotal: [''],
      shippingAmount: [''],
      shippingCancelled: [''],
      shippingInvoiced: [''],
      shippingRefunded: [''],
      shippingTaxAmount: [''],
      shippingTaxRefunded: [''],
      storeToBaseRate: [''],
      storeToOrderRate: [''],
      subtotal: [''],
      subtotalCancelled: [''],
      subtotalInvoiced: [''],
      subtotalRefunded: [''],
      taxAmount: [''],
      taxCancelled: [''],
      taxInvoiced: [''],
      taxRefunded: [''],
      totalCancelled: [''],
      totalInvoiced: [''],
      totalOfflineRefunded: [''],
      totalOnlineRefunded: [''],
      totalPaid: [''],
      itemsQty: [''],
      totalRefunded: [''],
      canShipPartially: [''],
      canShipPartiallyItem: [''],
      customerIsGuest: [''],
      customerNoteNotify: [''],
      billingAddressId: [''],
      customerGroupId: [''],
      editIncrement: [''],
      emailSent: [''],
      forcedShipmentWithInvoice: [''],
      paymentAuthExpiration: [''],
      quoteAddressId: [''],
      shippingAddressId: [''],
      adjustmentNegative: [''],
      adjustmentPositive: [''],
      baseAdjustmentPositive: [''],
      baseShippingDiscountAmount: [''],
      baseSubtotalInclTax: [''],
      baseTotalDue: [''],
      paymentAuthorizationAmount: [''],
      shippingDiscountAmount: [''],
      subtotalInclTax: [''],
      totalDue: [''],
      weight: [''],
      customerDob: [''],
      incrementId: [''],
      appliedRuleIds: [''],
      baseCurrencyCode: [''],
      customerEmail: ['', [Validators.required, Validators.pattern("^[a-z0-9._%+-]+@[a-z0-9.-]+.[a-z]{2,4}$")]],
      customerFirstname: ['', [Validators.required]],
      customerLastname: ['', Validators.required],
      customerMiddlename: [''],
      customerPrefix: [''],
      customerSuffix: [''],
      customerTaxvat: [''],
      discountDescription: [''],
      extCustomerId: [''],
      extOrderId: [''],
      globalCurrencyCode: [''],
      holdBeforeState: [''],
      holdBeforeStatus: [''],
      orderCurrencyCode: [''],
      originalIncrementId: [''],
      relationChildId: [''],
      relationChildRealId: [''],
      relationParentRealId: [''],
      remoteIp: [''],
      shippingMethod: [''],
      storeCurrencyCode: [''],
      storeName: [''],
      xForwardedFor: [''],
      customer_note: [''],
      createdDate: [''],
      updatedDate: [''],
      itemsCount: [''],
      customerGender: [''],
      hiddenTaxAmount: [''],
      baseHiddenTaxAmount: [''],
      shippingHiddenTaxAmount: [''],
      baseShippingHiddenTaxAmnt: [''],
      hiddenTaxInvoiced: [''],
      baseHiddenTaxInvoiced: [''],
      hiddenTaxRefunded: [''],
      baseHiddenTaxRefunded: [''],
      shippingInclTax: [''],
      baseShippingInclTax: [''],
      couponRuleName: [''],
      paypalIpnCustomerNotified: [''],
      giftMessageId: [''],
      pos: [''],
      billerId: [''],
      biller: [''],
      cgstAmount: [''],
      sgstAmount: [''],
      igstAmount: [''],
      inclusiveTax: [''],
      deliveryOption: [''],
      calculateShippingRateBasedOnVendors: [''],
      additionalDeliveryAmount: [''],
      prescriptionAttached: [''],
      prescriptionObject: [''],
      productTypeMedical: [''],
      additionalMedicalharge: [''],
      cess: [''],
      partialPaid: [''],
      partialPaidAmount: [''],
      remainingBalance: [''],
      vendorEnabled: [''],
      totalSupplierCommissionAmount: [''],
      supplierCommissionRule: [''],
      supplierCommissionRefunded: [''],
      supplierCommissionPercent: [''],
      supplierCommisionCancelled: [''],
      totalReferralCommissionAmount: [''],
      referralCommissionRule: [''],
      referralCommissionRefunded: [''],
      referralCommisionCancelled: [''],
      referalId: [''],
      referalProductId: [''],
      referalCustomerId: [''],
      codCharges: [''],
      secondaryStatus: [''],
      tip: [''],
      orderAdditionalInfo: [''],
      printDateTime:[''],
      orderDeliveryTime:[''],
      warehouseId:[''],
      warehouseLatitude:[''],
      warehouseLongitude:[''],
      salesFlatOrderItem: this.formBuilder.array([
        this.orderItemForm()
      ]),
      salesFlatOrderAddress: this.formBuilder.array([
        this.orderAddressForm()
      ]),
      salesFlatOrderPrescription: this.formBuilder.array([
        this.orderPrescriptionForm()
      ]),
      salesFlatOrderStatusHistory: this.formBuilder.array([
        this.orderCommentForm()
      ]),

      salesFlatCreditmemo: this.formBuilder.array([
        this.creditMemoForm()
      ]),

      salesFlatShipment: this.formBuilder.array([
        this.orderShipmentForm()
      ])

    });
    this.salesFlatOrderGridForm();
    this.salesFlatOrderPaymentForm();
    this.salesFlatInvoiceForm();



  }



  orderItemForm(): UntypedFormGroup {
    return this.formBuilder.group({
      itemId: [''],
      parentItemId: [''],
      quoteItemId: [''],
      storeId: [''],
      createdDate: [''],
      updatedDate: [''],
      productId: [''],
      productType: [''],
      productOptions: [''],
      weight: [''],
      isVirtual: [''],
      sku: [''],
      name: [''],
      description: [''],
      appliedRuleIds: [''],
      additionalData: [''],
      freeShipping: [''],
      isQtyecDimal: [''],
      noDiscount: [''],
      qtyBackordered: [''],
      qtyCancelled: [''],
      qtyInvoiced: [''],
      qty: [''],
      qtyRefunded: [''],
      qtyShipped: [''],
      baseCost: [''],
      price: [''],
      basePrice: [''],
      baseOriginalPrice: [''],
      taxPercent: [''],
      taxAmount: [''],
      baseTaxAmount: [''],
      taxInvoiced: [''],
      baseTaxInvoiced: [''],
      discountPercent: [''],
      discountAmount: [''],
      baseDiscountAmount: [''],
      discountInvoiced: [''],
      baseDiscountInvoiced: [''],
      amountRefunded: [''],
      baseAmountRefunded: [''],
      rowTotal: [''],
      baseRowTotal: [''],
      rowInvoiced: [''],
      baseRowInvoiced: [''],
      rowWeight: [''],
      baseTaxBeforeDiscount: [''],
      taxBeforeDiscount: [''],
      extOrderItemId: [''],
      lockedDoInvoice: [''],
      lockedDoShip: [''],
      priceInclTax: [''],
      basePriceInclTax: [''],
      rowTotalInclTax: [''],
      baseRowTotalInclTax: [''],
      hiddenTaxAmount: [''],
      baseHiddenTaxAmount: [''],
      hiddenTaxInvoiced: [''],
      baseHiddenTaxInvoiced: [''],
      hiddenTaxRefunded: [''],
      baseHiddenTaxRefunded: [''],
      isNominal: [''],
      taxCancelled: [''],
      hiddenTaxCancelled: [''],
      taxRefunded: [''],
      baseTaxRefunded: [''],
      discountRefunded: [''],
      baseDiscountRefunded: [''],
      giftMessageId: [''],
      giftMessageAvailable: [''],
      baseWeeeTaxAppliedAmount: [''],
      baseWeeeTaxAppliedRowAmnt: [''],
      weeeTaxAppliedAmount: [''],
      weeeTaxAppliedRowAmount: [''],
      weeeTaxApplied: [''],
      weeeTaxDisposition: [''],
      weeeTaxRowDisposition: [''],
      baseWeeeTaxDisposition: [''],
      baseWeeeTaxRowDisposition: [''],
      imageUrl: [''],
      gst: [''],
      cgst: [''],
      sgst: [''],
      igst: [''],
      cgstAmount: [''],
      sgstAmount: [''],
      igstAmount: [''],
      inclusiveTax: [''],
      unit: [''],
      supplierLatitude: [''],
      supplierLongitude: [''],
      supplierId: [''],
      supplierName: [''],
      shippingAmount: [''],
      stockInHand: [''],
      cess: [''],
      partialPaidAmount: [''],
      additionalMedicalCharge: [''],
      supplierCommissionPercent: [''],
      supplierCommissionRefunded: [''],
      supplierCommisionIndividual: [''],
      supplierCommisionBasedOnCategory: [''],
      supplierCommissionAmount: [''],
      categoryId: [''],
      supplierCommisionCancelled: [''],
      supplierCommisionRefunded: [''],
      referralCommissionPercent: [''],
      referralCommissionRefunded: [''],
      referralCommisionIndividual: [''],
      referralCommisionBasedOnCategory: [''],
      referralCommissionAmount: [''],
      referralCommisionCancelled: [''],
      message: [''],
      dateValue: [''],
      image: [''],
      imageCustomize:[''],
      customizeImage:[''],
      subChild: this.formBuilder.array([
        this.orderChildItemForm()
      ]),

    });
  }

  orderChildItemForm(): UntypedFormGroup {
    return this.formBuilder.group({
      entityId: [''],
      customerAddressId: [''],
      quoteAddressId: [''],
      regionId: [''],
      customerId: [''],
      fax: [''],
      region: [''],
      postCode: [''],
      lastName: [''],
      street: [''],
      city: [''],
      email: [''],
      telephone: [''],
      countryId: [''],
      firstName: [''],
      addressType: [''],
      prefix: [''],
      middleName: [''],
      suffix: [''],
      company: [''],
      vatId: [''],
      vatIsValid: [''],
      vatRequestId: [''],
      vatRequestDate: [''],
      vatRequestSuccess: [''],
      categoryId: ['']
    });
  }

  salesFlatOrderPaymentForm() {
    let control = this.formBuilder.group({
      entityId: [''],
      baseShippingCaptured: [''],
      shippingCaptured: [''],
      amountRefunded: [''],
      baseAmountPaid: [''],
      amountCancelled: [''],
      baseAmountAuthorized: [''],
      baseAmountPaidOnline: [''],
      baseAmountRefundedOnline: [''],
      baseShippingAmount: [''],
      shippingAmount: [''],
      amountPaid: [''],
      amountAuthorized: [''],
      baseAmountOrdered: [''],
      baseShippingRefunded: [''],
      shippingRefunded: [''],
      baseAmountRefunded: [''],
      amountOrdered: [''],
      baseAmountCancelled: [''],
      quotePaymentId: [''],
      additionalData: [''],
      ccExpMonth: [''],
      ccSsStartYear: [''],
      echeckBankName: [''],
      method: [''],
      ccDebugRequestBody: [''],
      ccSecureVerify: [''],
      protectionEligibility: [''],
      ccApproval: [''],
      ccLast4: [''],
      ccStatusDescription: [''],
      echeckType: [''],
      ccDebugResponseSerialized: [''],
      ccSsStartMonth: [''],
      echeckAccountType: [''],
      lastTransId: [''],
      ccCidStatus: [''],
      ccOwner: [''],
      ccType: [''],
      poNumber: [''],
      ccExpYear: [''],
      ccStatus: [''],
      echeckRoutingNumber: [''],
      accountStatus: [''],
      anetTransMethod: [''],
      ccDebugResponseBody: [''],
      ccSsIssue: [''],
      echeckAccountName: [''],
      ccAvsStatus: [''],
      ccNumberEnc: [''],
      ccTransId: [''],
      payboxRequestNumber: [''],
      addressStatus: [''],
      additionalInformation: [''],
    });

    this.firstFormGroup.addControl("salesFlatOrderPayment", control);

  }



  orderAddressForm(): UntypedFormGroup {
    return this.formBuilder.group({
      entityId: [''],
      customerAddressId: [''],
      quoteAddressId: [''],
      regionId: [''],
      customerId: [''],
      fax: [''],
      region: ['', Validators.required],
      postCode: ['', Validators.required],
      lastName: [''],
      street: ['', Validators.required],
      city: ['', Validators.required],
      email: [''],
      telephone: ['', [Validators.required]],
      countryId: [''],
      firstName: [''],
      addressType: [''],
      prefix: [''],
      middleName: [''],
      suffix: [''],
      company: [''],
      vatId: [''],
      vatIsValid: [''],
      vatRequestId: [''],
      vatRequestDate: [''],
      vatRequestSuccess: [''],
      state: [''],
    });
  }


  orderCommentForm(): UntypedFormGroup {
    return this.formBuilder.group({
      entityId: [''],
      isCustomerNotified: new UntypedFormControl(0),
      isVisibleOnFront: new UntypedFormControl(0),
      comment: ['', []],
      status: [''],
      entityName: [''],
    });
  }

  orderPrescriptionForm(): UntypedFormGroup {
    return this.formBuilder.group({
      prescriptionId: [''],
      value: [''],
      customerId: [''],

    });
  }

  salesFlatOrderGridForm() {
    let control = this.formBuilder.group({
      entityId: [''],
      status: [''],
      orderId: [''],
      storeName: [''],
      customerId: [''],
      baseGrandTotal: [''],
      baseTotalPaid: [''],
      grandTotal: [''],
      totalPaid: [''],
      incrementId: [''],
      baseCurrencyCode: [''],
      orderCurrencyCode: [''],
      shippingName: [''],
      billingName: [''],
      supplierId: [''],
      supplierName: [''],
    });

    this.firstFormGroup.addControl("salesFlatOrderGrid", control);

  }


  //invoice

  salesFlatInvoiceForm() {
    let control = this.formBuilder.group({
      entityId: [''],
      storeid: [''],
      orderId: [''],
      baseGrandTotal: [''],
      shippingTaxAmount: [''],
      taxAmount: [''],
      baseTaxAmount: [''],
      storeToOrderRate: [''],
      baseShippingTaxAmount: [''],
      baseDiscountAmount: [''],
      baseToOrderRate: [''],
      grandTotal: [''],
      shippingAmount: [''],
      subtotalInclTax: [''],
      baseSubtotalInclTax: [''],
      storeToBaseRate: [''],
      baseShippingAmount: [''],
      totalQty: [''],
      baseToGlobalRate: [''],
      subtotal: [''],
      baseSubtotal: [''],
      discountAmount: [''],
      billingAddressId: [''],
      isUsedForRefund: [''],
      emailSent: [''],
      canVoidFlag: [''],
      state: [''],
      shippingAddressId: [''],
      storeCurrencyCode: [''],
      transactionId: [''],
      orderCurrencyCode: [''],
      baseCurrencyCode: [''],
      globalCurrencyCode: [''],
      incrementId: [''],
      createdDate: [''],
      updatedDate: [''],
      hiddenTaxAmount: [''],
      baseHiddenTaxAmount: [''],
      shippingHiddenTaxAmount: [''],
      baseShippingHiddenTaxAmnt: [''],
      shippingInclTax: [''],
      baseShippingInclTax: [''],
      baseTotalRefunded: [''],
      discountDescription: [''],
      codFee: [''],
      baseCodFee: [''],
      codTaxAmount: [''],
      baseCodTaxAmount: [''],
      multifeesAmount: new UntypedFormControl(0.0),
      baseMultifeesAmount: new UntypedFormControl(0.0),
      multifeesTaxAmount: new UntypedFormControl(0.0),
      baseMultifeesTaxAmount: new UntypedFormControl(0.0),
      detailsMultifees: new UntypedFormControl(0.0),
      additionalMedicalharge: [''],
      cgstAmount: [''],
      sgstAmount: [''],
      igstAmount: [''],
      inclusiveTax: [''],
      cess: [''],
      totalSupplierCommissionAmount: [''],
      supplierCommissionRule: [''],
      supplierCommissionRefunded: [''],
      supplierCommissionPercent: [''],
      supplierCommisionCancelled: [''],
      totalReferralCommissionAmount: [''],
      referralCommissionRule: [''],
      referralCommissionRefunded: [''],
      referralCommisionCancelled: [''],
      referalId: [''],
      referalProductId: [''],
      referalCustomerId: [''],
      codCharges: [''],

      salesFlatInvoiceItem: this.formBuilder.array([
        this.SalesFlatInvoiceItemForm()
      ]),
      salesFlatInvoiceComment: this.formBuilder.array([
        this.salesFlatInvoiceCommentForm()
      ]),
    });

    this.firstFormGroup.addControl("salesFlatInvoice", control);

  }


  SalesFlatInvoiceItemForm(): UntypedFormGroup {
    return this.formBuilder.group({
      entityId: [''],
      parentId: [''],
      basePrice: [''],
      taxAmount: [''],
      baseRowTotal: [''],
      discountAmount: [''],
      rowTotal: [''],
      baseDiscountAmount: [''],
      priceInclTax: [''],
      baseTaxAmount: [''],
      basePriceInclTax: [''],
      qty: [''],
      baseCost: [''],
      price: [''],
      baseRowTotalInclTax: [''],
      rowTotalInclTax: [''],
      productId: [''],
      orderItemId: [''],
      additionalData: [''],
      description: [''],
      sku: [''],
      name: [''],
      hiddenTaxAmount: [''],
      baseHiddenTaxAmount: [''],
      baseWeeeTaxAppliedAmount: [''],
      baseWeeeTaxAppliedRowAmnt: [''],
      weeeTaxAppliedAmount: [''],
      weeeTaxAppliedRowAmount: [''],
      weeeTaxApplied: [''],
      weeeTaxDisposition: [''],
      weeeTaxRowDisposition: [''],
      baseWeeeTaxDisposition: [''],
      baseWeeeTaxRowDisposition: [''],
      supplierLatitude: [''],
      supplierLongitude: [''],
      supplierId: [''],
      supplierName: [''],
      shippingAmount: [''],
      shippingAmountInitial: [''],
      cgstAmount: [''],
      sgstAmount: [''],
      igstAmount: [''],
      inclusiveTax: [''],
      cgst: [''],
      sgst: [''],
      igst: [''],
      cess: [''],
      stockInHand: [''],
      supplierCommissionPercent: [''],
      supplierCommissionRefunded: [''],
      supplierCommisionIndividual: [''],
      supplierCommisionBasedOnCategory: [''],
      supplierCommissionAmount: [''],
      supplierCommisionCancelled: [''],
      referralCommissionPercent: [''],
      referralCommissionRefunded: [''],
      referralCommisionIndividual: [''],
      referralCommisionBasedOnCategory: [''],
      referralCommissionAmount: [''],
      referralCommisionCancelled: ['']

    });
  }


  salesFlatInvoiceCommentForm(): UntypedFormGroup {
    return this.formBuilder.group({
      entityId: [''],
      parentId: [''],
      isCustomerNotified: [''],
      isVisibleOnFront: [''],
      comment: [''],
      createdDate: [''],
    });
  }


  //shipment
  orderShipmentForm() {
    return this.formBuilder.group({
      entityId: [''],
      storeId: [''],
      totalWeight: [''],
      totalQty: [''],
      emailSent: new UntypedFormControl(0),
      customerId: [''],
      shippingAddressId: [''],
      billingAddressId: [''],
      shipmentStatus: [''],
      incrementId: [''],
      createdDate: [''],
      packages: [''],
      shippingLabel: [''],
      shippingAmount: [''],
      supplierLatitude: [''],
      supplierLongitude: [''],
      supplierId: [''],
      supplierName: [''],
      additionalMedicalCharge: [''],
      peopleId: [''],
      additionalCost: [''],
      customPrice: [''],
      grandTotal: [''],
      amountToBeCollected: [''],
      startOtp: [''],
      endOtp: [''],
      deliveryPeopleCommision: [''],
      salesFlatShipmentItem: this.formBuilder.array([
        this.shippingItemForm()
      ]),

    });
  }


  shippingItemForm(): UntypedFormGroup {
    return this.formBuilder.group({
      itemId: [''],
      rowTotal: [''],
      price: [''],
      weight: [''],
      qty: [''],
      productId: [''],
      orderItemId: [''],
      additionalData: [''],
      description: [''],
      name: [''],
      sku: [''],

    });
  }

  ///creditmemo

  creditMemoForm() {
    return this.formBuilder.group({
      entityId: [''],
      storeId: [''],
      adjustmentPositive: new UntypedFormControl(0),
      baseShippingTaxAmount: [''],
      storeToOrderRate: [''],
      baseDiscountAmount: [''],
      baseToOrderRate: [''],
      grandTotal: [''],
      baseAdjustmentNegative: [''],
      baseSubtotalInclTax: [''],
      shippingAmount: [''],
      subtotalInclTax: [''],
      adjustmentNegative: new UntypedFormControl(0),
      baseShippingAmount: [''],
      storeToBaseRate: [''],
      baseToGlobalRate: [''],
      baseAdjustment: [''],
      baseSubtotal: [''],
      discountAmount: [''],
      subtotal: [''],
      adjustment: [''],
      baseGrandTotal: [''],
      baseAdjustmentPositive: [''],
      baseTaxAmount: [''],
      password: [''],
      taxAmount: [''],
      orderId: [''],
      emailSent: [''],
      creditmemoStatus: [''],
      state: [''],
      shippingAddressId: [''],
      billingAddressId: [''],
      invoiceId: [''],
      storeCurrencyCode: [''],
      orderCurrencyCode: [''],
      baseCurrencyCode: [''],
      globalCurrencyCode: [''],
      transactionId: [''],
      incrementId: [''],
      createdDate: [''],
      updatedDate: [''],
      hiddenTaxAmount: [''],
      baseHiddenTaxAmount: [''],
      shippingHiddenTaxAmount: [''],
      baseShippingHiddenTaxAmnt: [''],
      shippingInclTax: [''],
      baseShippingInclTax: [''],
      discountDescription: [''],
      codFee: [''],
      baseCodFee: [''],
      codTaxAmount: [''],
      baseCodTaxAmount: [''],
      multifeesAmount: new UntypedFormControl(0.0),
      baseMultifeesAmount: new UntypedFormControl(0.0),
      multifeesTaxAmount: new UntypedFormControl(0.0),
      baseMultifeesTaxAmount: new UntypedFormControl(0.0),
      detailsMultifees: [''],
      cgstAmount: [''],
      sgstAmount: [''],
      igstAmount: [''],
      inclusiveTax: [''],
      additionalMedicalharge: [''],
      totalSupplierCommissionAmount: [''],
      supplierCommissionRule: [''],
      supplierCommissionRefunded: [''],
      supplierCommissionPercent: [''],
      supplierCommisionCancelled: [''],
      referral_commission_refunded: [''],
      referral_commision_percent: [''],
      referral_commision_cancelled: [''],
      referral_commission_rule: [''],
      total_referral_commission_amount: [''],
      salesFlatCreditmemoItem: this.formBuilder.array([
        this.salesFlatCreditmemoItemForm()
      ]),
    });
  }

  ///Init Order creditMemoItem Form
  salesFlatCreditmemoItemForm(): UntypedFormGroup {
    return this.formBuilder.group({
      entityId: [''],
      parentId: [''],
      basePrice: [''],
      taxAmount: [''],
      baseRowTotal: [''],
      discountAmount: [''],
      discountAmountInitial: [''],
      rowTotal: [''],
      baseDiscountAmount: [''],
      priceInclTax: [''],
      baseTaxAmount: [''],
      basePriceInclTax: [''],
      qty: [''],
      qtyi: [''],
      baseCost: [''],
      price: [''],
      baseRowTotalInclTax: [''],
      rowTotalInclTax: [''],
      productId: [''],
      orderItemId: [''],
      additionalData: [''],
      description: [''],
      sku: [''],
      name: [''],
      hiddenTaxAmount: [''],
      baseHiddenTaxAmount: [''],
      baseWeeeTaxAppliedAmount: [''],
      baseWeeeTaxAppliedRowAmnt: [''],
      weeeTaxAppliedAmount: [''],
      weeeTaxAppliedRowAmount: [''],
      weeeTaxApplied: [''],
      weeeTaxDisposition: [''],
      weeeTaxRowDisposition: [''],
      baseWeeeTaxDisposition: [''],
      baseWeeeTaxRowDisposition: [''],
      taxPercent: [''],
      supplierLatitude: [''],
      supplierLongitude: [''],
      supplierId: [''],
      supplierName: [''],
      shippingAmount: [''],
      shippingAmountInitial: [''],
      shippingAmountFinal: [''],
      cgst: [''],
      sgst: [''],
      igst: [''],
      cgstAmount: [''],
      sgstAmount: [''],
      igstAmount: [''],
      cgstAmountd: [''],
      sgstAmountd: [''],
      igstAmountd: [''],
      inclusiveTax: [''],
      additionalMedicalharge: [''],
      unit: [''],
      supplierCommissionPercent: [''],
      supplierCommissionRefunded: [''],
      supplierCommisionIndividual: [''],
      supplierCommisionBasedOnCategory: [''],
      supplierCommissionAmount: [''],
      supplierCommisionCancelled: [''],
      referral_commission_refunded: [''],
      referral_commision_percent: [''],
      referral_commision_cancelled: [''],
      referral_commission_rule: [''],
      total_referral_commission_amount: [''],
    });
  }




  getOrderById() {
    // let customerId = 38813
    let entityId = this.activatedRoute.snapshot.params['entityId'];
    this.orderService.getOrderById(entityId)
      .subscribe(
        (orders: Order) => {

        //  this.deliveryPerson = orders['salesFlatShipment'][0].peopleId;
        //  console.log(this.deliveryPerson);
          this.order = orders;
          this.init = true;
          this.editOrderList(orders);
          if (orders['deliveryOption'] == 'Pick Up From Store') {
            this.deliveryAddressLabel = 'Store Address';

            //   this.editOrderList(this.firstFormGroup.value.status)
          }
          this.address=this.order.salesFlatOrderAddress[0];
          this.warehouseLatitude = this.order.warehouseLatitude;
          this.warehouseLongitude = this.order.warehouseLongitude;

          this.secondaryStatus = orders['secondaryStatus'] != null ? orders['secondaryStatus'] : this.firstFormGroup.value.status;
          this.getOrderStatus(this.firstFormGroup.value.status)


        },
        error => {
        }
      )
  }


  editOrderList(orderview: any) {
    this.firstFormGroup.patchValue({
      entityId: orderview.entityId,
      status: orderview.status,
      couponCode: orderview.couponCode,
      protectCode: orderview.protectCode,
      shippingDescription: orderview.shippingDescription,
      isVirtual: orderview.isVirtual,
      storeId: orderview.storeId,
      customerId: orderview.customerId,
      baseDiscountAmount: orderview.baseDiscountAmount,
      baseDiscountCancelled: orderview.baseDiscountCancelled,
      baseDiscountInvoice: orderview.baseDiscountCancelled,
      baseShippingRefunded: orderview.baseShippingRefunded,
      baseGrandTotal: orderview.baseGrandTotal,
      baseShippingTaxAmount: orderview.baseShippingTaxAmount,
      baseShippingTaxRefunded: orderview.baseShippingTaxRefunded,
      baseSubtotal: orderview.baseSubtotal,
      baseSubtotalCancelled: orderview.baseSubtotalCancelled,
      baseSubtotalInvoiced: orderview.baseSubtotalInvoiced,
      baseTaxAmount: orderview.baseTaxAmount,
      baseTaxCancelled: orderview.baseTaxCancelled,
      baseTaxInvoiced: orderview.baseTaxInvoiced,
      baseTaxRefunded: orderview.baseTaxRefunded,
      baseToGlobalRate: orderview.baseToGlobalRate,
      baseToOrderRate: orderview.baseToOrderRate,
      baseTotalCancelled: orderview.baseTotalCancelled,
      baseTotalInvoiced: orderview.baseTotalInvoiced,
      baseTotalInvoicedCost: orderview.baseTotalInvoicedCost,
      baseTotalOfflineRefunded: orderview.baseTotalOfflineRefunded,
      baseTotalOnlineRefunded: orderview.baseTotalOnlineRefunded,
      baseTotalPaid: orderview.baseTotalPaid,
      baseTotalQtyOrdered: orderview.baseTotalQtyOrdered,
      baseTotalRefunded: orderview.baseTotalRefunded,
      discountAmount: orderview.discountAmount,
      discountCancelled: orderview.discountCancelled,
      discountInvoiced: orderview.discountInvoiced,
      discountRefunded: orderview.discountRefunded,
      grandTotal: orderview.grandTotal,
      shippingAmount: orderview.shippingAmount,
      shippingCancelled: orderview.shippingCancelled,
      shippingInvoiced: orderview.shippingInvoiced,
      shippingRefunded: orderview.shippingRefunded,
      shippingTaxAmount: orderview.shippingTaxAmount,
      shippingTaxRefunded: orderview.shippingTaxRefunded,
      storeToBaseRate: orderview.storeToBaseRate,
      storeToOrderRate: orderview.storeToOrderRate,
      subtotal: orderview.subtotal,
      subtotalCancelled: orderview.subtotalCancelled,
      subtotalInvoiced: orderview.subtotalInvoiced,
      subtotalRefunded: orderview.subtotalRefunded,
      taxAmount: orderview.taxAmount,
      taxCancelled: orderview.taxCancelled,
      taxInvoiced: orderview.taxInvoiced,
      taxRefunded: orderview.taxRefunded,
      totalCancelled: orderview.totalCancelled,
      totalInvoiced: orderview.totalInvoiced,
      totalOfflineRefunded: orderview.totalOfflineRefunded,
      totalOnlineRefunded: orderview.totalOnlineRefunded,
      totalPaid: orderview.totalPaid,
      itemsQty: orderview.itemsQty,
      totalRefunded: orderview.totalRefunded,
      canShipPartially: orderview.canShipPartially,
      canShipPartiallyItem: orderview.canShipPartiallyItem,
      customerIsGuest: orderview.customerIsGuest,
      customerNoteNotify: orderview.customerNoteNotify,
      billingAddressId: orderview.billingAddressId,
      customerGroupId: orderview.customerGroupId,
      editIncrement: orderview.editIncrement,
      emailSent: 0,
      forcedShipmentWithInvoice: orderview.forcedShipmentWithInvoice,
      paymentAuthExpiration: orderview.paymentAuthExpiration,
      quoteAddressId: orderview.quoteAddressId,
      shippingAddressId: orderview.shippingAddressId,
      adjustmentNegative: orderview.adjustmentNegative,
      adjustmentPositive: orderview.adjustmentPositive,
      baseAdjustmentPositive: orderview.baseAdjustmentPositive,
      baseShippingDiscountAmount: orderview.baseShippingDiscountAmount,
      baseSubtotalInclTax: orderview.baseSubtotalInclTax,
      baseTotalDue: orderview.baseTotalDue,
      paymentAuthorizationAmount: orderview.paymentAuthorizationAmount,
      shippingDiscountAmount: orderview.shippingDiscountAmount,
      subtotalInclTax: orderview.subtotalInclTax,
      totalDue: orderview.totalDue,
      weight: orderview.weight,
      customerDob: orderview.customerDob,
      incrementId: orderview.incrementId,
      appliedRuleIds: orderview.appliedRuleIds,
      baseCurrencyCode: orderview.baseCurrencyCode,
      customerEmail: orderview.customerEmail,
      customerFirstname: orderview.customerFirstname,
      customerLastname: orderview.customerLastname,
      customerMiddlename: orderview.customerMiddlename,
      customerPrefix: orderview.customerPrefix,
      customerSuffix: orderview.customerSuffix,
      customerTaxvat: orderview.customerTaxvat,
      discountDescription: orderview.discountDescription,
      extCustomerId: orderview.extCustomerId,
      extOrderId: orderview.extOrderId,
      globalCurrencyCode: orderview.globalCurrencyCode,
      holdBeforeState: orderview.holdBeforeState,
      holdBeforeStatus: orderview.holdBeforeStatus,
      orderCurrencyCode: orderview.orderCurrencyCode,
      originalIncrementId: orderview.originalIncrementId,
      relationChildId: orderview.relationChildId,
      relationChildRealId: orderview.relationChildRealId,
      relationParentRealId: orderview.relationParentRealId,
      remoteIp: orderview.remoteIp,
      shippingMethod: orderview.shippingMethod,
      storeCurrencyCode: orderview.storeCurrencyCode,
      storeName: orderview.storeName,
      xForwardedFor: orderview.xForwardedFor,
      customer_note: orderview.customer_note,
      createdDate: orderview.createdDate,
      updatedDate: orderview.updatedDate,
      itemsCount: orderview.itemsCount,
      customerGender: orderview.customerGender,
      hiddenTaxAmount: orderview.hiddenTaxAmount,
      baseHiddenTaxAmount: orderview.baseHiddenTaxAmount,
      shippingHiddenTaxAmount: orderview.shippingHiddenTaxAmount,
      baseShippingHiddenTaxAmnt: orderview.baseShippingHiddenTaxAmnt,
      hiddenTaxInvoiced: orderview.hiddenTaxAmount,
      baseHiddenTaxInvoiced: orderview.baseHiddenTaxInvoiced,
      hiddenTaxRefunded: orderview.hiddenTaxRefunded,
      baseHiddenTaxRefunded: orderview.baseHiddenTaxRefunded,
      shippingInclTax: orderview.shippingInclTax,
      baseShippingInclTax: orderview.baseShippingInclTax,
      couponRuleName: orderview.couponRuleName,
      paypalIpnCustomerNotified: orderview.paypalIpnCustomerNotified,
      giftMessageId: orderview.giftMessageId,
      pos: orderview.pos,
      billerId: orderview.billerId,
      biller: orderview.biller,
      deliveryOption: orderview.deliveryOption,
      calculateShippingRateBasedOnVendors: orderview.calculateShippingRateBasedOnVendors,
      additionalDeliveryAmount: orderview.additionalDeliveryAmount,
      prescriptionAttached: orderview.prescriptionAttached,
      prescriptionObject: orderview.prescriptionObject,
      productTypeMedical: orderview.productTypeMedical,
      additionalMedicalharge: orderview.additionalMedicalharge,
      cgstAmount: orderview.cgstAmount,
      sgstAmount: orderview.sgstAmount,
      igstAmount: orderview.igstAmount,
      inclusiveTax: orderview.inclusiveTax,
      cess: orderview.cess,
      partialPaid: orderview.partialPaid,
      partialPaidAmount: orderview.partialPaidAmount,
      remainingBalance: orderview.remainingBalance,
      vendorEnabled: orderview.vendorEnabled,
      totalSupplierCommissionAmount: orderview.totalSupplierCommissionAmount,
      supplierCommissionRule: orderview.supplierCommissionRule,
      supplierCommissionPercent: orderview.supplierCommissionPercent,
      supplierCommisionCancelled: orderview.supplierCommisionCancelled,
      supplierCommissionRefunded: orderview.supplierCommissionRefunded,
      totalReferralCommissionAmount: orderview.totalReferralCommissionAmount,
      referralCommissionRule: orderview.referralCommissionRule,
      referralCommissionRefunded: orderview.referralCommissionRefunded,
      referralCommisionCancelled: orderview.referralCommisionCancelled,
      referalId: orderview.referalId,
      referalProductId: orderview.referalProductId,
      referalCustomerId: orderview.referalCustomerId,
      codCharges: orderview.codCharges,
      secondaryStatus: orderview.secondaryStatus,
      tip: orderview.tip,
      orderAdditionalInfo: orderview.orderAdditionalInfo,
      printDateTime: orderview.printDateTime,
      orderDeliveryTime: orderview.orderDeliveryTime,
      warehouseId: orderview.warehouseId,
      warehouseLatitude: orderview.warehouseLatitude,
      warehouseLongitude: orderview.warehouseLongitude,
    });

    this.setValueForSalesFlatOrderGrid(orderview.salesFlatOrderGrid)

    this.firstFormGroup.setControl('salesFlatOrderAddress', this.setValueOrderAddress(orderview.salesFlatOrderAddress));
    // this.firstFormGroup.setControl('salesFlatOrderPayment', this.editOrderItemList1(orderview.salesFlatOrderPayment));
    this.firstFormGroup.setControl('salesFlatOrderStatusHistory', this.setValueOrderStatusHistory(orderview.salesFlatOrderStatusHistory));
    this.firstFormGroup.setControl('salesFlatOrderItem', this.setValueOrderItem(orderview.salesFlatOrderItem));
    this.firstFormGroup.setControl('salesFlatShipment', this.setValueOrderShipmentForm(orderview.salesFlatShipment));
    if (orderview.salesFlatOrderPrescription.length > 0) {
      this.firstFormGroup.setControl('salesFlatOrderPrescription', this.setValueOrderPrescription(orderview.salesFlatOrderPrescription));
      this.visiblePrescriptionLayout = true;
    } else {
      this.visiblePrescriptionLayout = false;
      this.firstFormGroup.value.salesFlatOrderPrescription = [];
    }
  }


  setValueOrderShipmentForm(orderItemList: any[]): UntypedFormArray {
    const formArray = new UntypedFormArray([]);
    orderItemList.forEach(salesFlatShipment => {
      formArray.push(this.formBuilder.group({
        shippingAddressId: salesFlatShipment.shippingAddressId,
        billingAddressId: salesFlatShipment.billingAddressId,
        incrementId: salesFlatShipment.incrementId,
        packages: salesFlatShipment.packages,
        shippingLabel: salesFlatShipment.shippingLabel,
        shippingAmount: salesFlatShipment.shippingAmount,
        supplierLatitude: salesFlatShipment.supplierLatitude,
        supplierLongitude: salesFlatShipment.supplierLongitude,
        supplierId: salesFlatShipment.supplierId,
        supplierName: salesFlatShipment.supplierName,
        additionalCost: salesFlatShipment.additionalCost,
        customPrice: salesFlatShipment.customPrice,
        additionalMedicalCharge: salesFlatShipment.additionalMedicalCharge,
        grandTotal: salesFlatShipment.grandTotal,
        peopleId: salesFlatShipment.peopleId,
        amountToBeCollected: salesFlatShipment.amountToBeCollected,
        startOtp: salesFlatShipment.startOtp,
        endOtp: salesFlatShipment.endOtp,
        deliveryPeopleCommision: salesFlatShipment.deliveryPeopleCommision,

      }));
    });
    return formArray;
  }


  setValueOrderPrescription(prescription: any): UntypedFormArray {
    const formArray = new UntypedFormArray([]);
    prescription.forEach(s => {
      formArray.push(this.formBuilder.group({
        prescriptionId: s.prescriptionId,
        value: s.value,
        customerId: s.customerId,


      }));
    });
    return formArray;
  }

  setValueForSalesFlatOrderGrid(salesFlatOrderGrid: any) {

    salesFlatOrderGrid = {
      entityId: salesFlatOrderGrid.entityId,
      status: salesFlatOrderGrid.status,
      storeName: salesFlatOrderGrid.storeName,
      customerId: salesFlatOrderGrid.customerId,
      baseGrandTotal: salesFlatOrderGrid.baseGrandTotal,
      baseTotalPaid: salesFlatOrderGrid.baseTotalPaid,
      grandTotal: salesFlatOrderGrid.grandTotal,
      totalPaid: salesFlatOrderGrid.totalPaid,
      incrementId: salesFlatOrderGrid.incrementId,
      baseCurrencyCode: salesFlatOrderGrid.baseCurrencyCode,
      orderCurrencyCode: salesFlatOrderGrid.orderCurrencyCode,
      shippingName: salesFlatOrderGrid.shippingName,
      billingName: salesFlatOrderGrid.billingName,
      supplierId: salesFlatOrderGrid.supplierId,
      supplierName: salesFlatOrderGrid.supplierName,

    }
    this.firstFormGroup.get('salesFlatOrderGrid').patchValue(salesFlatOrderGrid);
  }

  setValueOrderAddress(orderItemList: any[]): UntypedFormArray {
    const formArray = new UntypedFormArray([]);
    orderItemList.forEach(s => {
      formArray.push(this.formBuilder.group({
        entityId: s.entityId,
        customerAddressId: s.customerAddressId,
        quoteAddressId: s.quoteAddressId,
        regionId: s.regionId,
        customerId: s.customerId,
        fax: s.fax,
        region: s.region,
        postCode: s.postCode,
        lastName: s.lastName,
        street: s.street,
        city: s.city,
        email: s.email,
        telephone: s.telephone,
        countryId: s.countryId,
        firstName: s.firstName,
        addressType: s.addressType,
        prefix: s.prefix,
        middleName: s.middleName,
        suffix: s.suffix,
        company: s.company,
        vatId: s.vatId,
        vatIsValid: s.vatIsValid,
        vatRequestId: s.vatRequestId,
        vatRequestDate: s.vatRequestDate,
        vatRequestSuccess: s.vatRequestSuccess,
        state: s.state,


      }));
    });
    return formArray;
  }



  setValueOrderStatusHistory(orderItemList: any[]): UntypedFormArray {
    const formArray = new UntypedFormArray([]);
    orderItemList.forEach(s => {
      formArray.push(this.formBuilder.group({
        entityId: s.entityId,
        isCustomerNotified: s.isCustomerNotified,
        isVisibleOnFront: s.isVisibleOnFront,
        comment: s.comment,
        status: s.status,
        createdDate: s.createdDate,
        entityName: s.entityName,

      }));
    });
    return formArray;
  }
  setValueOrderItem(orderItemList: any[]): UntypedFormArray {
    const formArray = new UntypedFormArray([]);
    orderItemList.forEach(s => {
      formArray.push(this.formBuilder.group({
        itemId: s.itemId,
        parentItemId: s.parentItemId,
        quoteItemId: s.quoteItemId,
        storeId: s.storeId,
        createdDate: s.createdDate,
        updatedDate: s.updatedDate,
        productId: s.productId,
        productType: s.productType,
        productOptions: s.productOptions,
        weight: s.weight,
        isVirtual: s.isVirtual,
        sku: s.sku,
        name: s.name,
        description: s.description,
        appliedRuleIds: s.appliedRuleIds,
        additionalData: s.additionalData,
        freeShipping: s.freeShipping,
        isQtyecDimal: s.isQtyecDimal,
        noDiscount: s.noDiscount,
        qtyBackordered: s.qtyBackordered,
        qtyCancelled: s.qtyCancelled == null ? 0.0 : s.qtyCancelled,
        qtyInvoiced: s.qtyInvoiced == null ? 0.0 : s.qtyInvoiced,
        qty: s.qty,
        qtyRefunded: s.qtyRefunded == null ? 0.0 : s.qtyRefunded,
        qtyShipped: s.qtyShipped == null ? 0.0 : s.qtyShipped,
        baseCost: s.baseCost,
        price: s.price,
        basePrice: s.basePrice,
        baseOriginalPrice: s.baseOriginalPrice,
        taxPercent: s.taxPercent,
        taxAmount: s.taxAmount,
        baseTaxAmount: s.baseTaxAmount,
        taxInvoiced: s.taxInvoiced,
        baseTaxInvoiced: s.baseTaxInvoiced,
        discountPercent: s.discountPercent,
        discountAmount: s.discountAmount,
        baseDiscountAmount: s.baseDiscountAmount,
        discountInvoiced: s.discountInvoiced,
        baseDiscountInvoiced: s.baseDiscountInvoiced,
        amountRefunded: s.amountRefunded,
        baseAmountRefunded: s.baseAmountRefunded,
        rowTotal: s.rowTotal,
        baseRowTotal: s.baseRowTotal,
        rowInvoiced: s.rowInvoiced,
        baseRowInvoiced: s.baseRowInvoiced,
        rowWeight: s.rowWeight,
        baseTaxBeforeDiscount: s.baseTaxBeforeDiscount,
        taxBeforeDiscount: s.taxBeforeDiscount,
        extOrderItemId: s.extOrderItemId,
        lockedDoInvoice: s.lockedDoInvoice,
        lockedDoShip: s.lockedDoShip,
        priceInclTax: s.priceInclTax,
        basePriceInclTax: s.basePriceInclTax,
        rowTotalInclTax: s.rowTotalInclTax,
        baseRowTotalInclTax: s.baseRowTotalInclTax,
        hiddenTaxAmount: s.hiddenTaxAmount,
        baseHiddenTaxAmount: s.baseHiddenTaxAmount,
        hiddenTaxInvoiced: s.hiddenTaxInvoiced,
        baseHiddenTaxInvoiced: s.baseHiddenTaxInvoiced,
        hiddenTaxRefunded: s.hiddenTaxRefunded,
        baseHiddenTaxRefunded: s.baseHiddenTaxRefunded,
        isNominal: s.isNominal,
        taxCancelled: s.taxCancelled,
        hiddenTaxCancelled: s.hiddenTaxCancelled,
        taxRefunded: s.taxRefunded,
        baseTaxRefunded: s.baseTaxRefunded,
        discountRefunded: s.discountRefunded,
        baseDiscountRefunded: s.baseAmountRefunded,
        giftMessageId: s.giftMessageId,
        giftMessageAvailable: s.giftMessageAvailable,
        baseWeeeTaxAppliedAmount: s.baseWeeeTaxAppliedAmount,
        baseWeeeTaxAppliedRowAmnt: s.baseWeeeTaxAppliedRowAmnt,
        weeeTaxAppliedAmount: s.weeeTaxAppliedAmount,
        weeeTaxAppliedRowAmount: s.baseWeeeTaxAppliedRowAmnt,
        weeeTaxApplied: s.weeeTaxApplied,
        weeeTaxDisposition: s.weeeTaxDisposition,
        weeeTaxRowDisposition: s.weeeTaxRowDisposition,
        baseWeeeTaxDisposition: s.baseWeeeTaxDisposition,
        baseWeeeTaxRowDisposition: s.baseWeeeTaxRowDisposition,
        imageUrl: s.imageUrl,
        unit: s.unit,
        supplierLatitude: s.supplierLatitude,
        supplierLongitude: s.supplierLongitude,
        supplierId: s.supplierId,
        supplierName: s.supplierName,
        shippingAmount: s.shippingAmount == null ? 0.0 : s.shippingAmount,
        cgstAmount: s.cgstAmount,
        sgstAmount: s.sgstAmount,
        igstAmount: s.igstAmount,
        gst: s.gst,
        cgst: s.cgst,
        sgst: s.sgst,
        igst: s.igst,
        inclusiveTax: s.inclusiveTax,
        stockInHand: s.stockInHand,
        cess: s.cess,
        partialPaidAmount: s.partialPaidAmount,
        additionalMedicalCharge: s.additionalMedicalCharge,
        supplierCommissionPercent: s.supplierCommissionPercent,
        supplierCommissionRefunded: s.supplierCommissionRefunded,
        supplierCommisionIndividual: s.supplierCommisionIndividual,
        supplierCommisionBasedOnCategory: s.supplierCommisionBasedOnCategory,
        supplierCommissionAmount: s.supplierCommissionAmount,
        categoryId: s.categoryId,
        supplierCommisionCancelled: s.supplierCommisionCancelled,
        referralCommissionPercent: s.referralCommissionPercent,
        referralCommissionRefunded: s.referralCommissionRefunded,
        referralCommisionIndividual: s.referralCommisionIndividual,
        referralCommisionBasedOnCategory: s.referralCommisionBasedOnCategory,
        referralCommissionAmount: s.referralCommissionAmount,
        referralCommisionCancelled: s.referralCommisionCancelled,
        message: s.message,
        dateValue: s.dateValue,
        imageCustomize: s.imageCustomize,
        customizeImage: s.customizeImage,
        image: this.getImage(s.imageUrl),
        subChild: this.editOrderSubItemList(s.subChild)
      }));
    });

    return formArray;
  }

  editOrderSubItemList(orderItemList: SalesFlatOrderItem[]): UntypedFormArray {
    const formArray = new UntypedFormArray([]);
    orderItemList.forEach(s => {
      formArray.push(this.formBuilder.group({
        itemId: s.itemId,
        parentItemId: s.parentItemId,
        quoteItemId: s.quoteItemId,
        storeId: s.storeId,
        createdDate: s.createdDate,
        updatedDate: s.updatedDate,
        productId: s.productId,
        productType: s.productType,
        productOptions: s.productOptions,
        weight: s.weight,
        isVirtual: s.isVirtual,
        sku: s.sku,
        name: s.name,
        description: s.description,
        appliedRuleIds: s.appliedRuleIds,
        additionalData: s.additionalData,
        freeShipping: s.freeShipping,
        isQtyecDimal: s.isQtyecDimal,
        noDiscount: s.noDiscount,
        qtyBackordered: s.qtyBackordered,
        qtyCanceled: s.qtyCanceled,
        qtyInvoiced: s.qtyInvoiced,
        qty: s.qty,
        qtyRefunded: s.qtyRefunded,
        qtyShipped: s.qtyShipped,
        baseCost: s.baseCost,
        price: s.price,
        basePrice: s.basePrice,
        baseOriginalPrice: s.baseOriginalPrice,
        taxPercent: s.taxPercent,
        taxAmount: s.taxAmount,
        baseTaxAmount: s.baseTaxAmount,
        taxInvoiced: s.taxInvoiced,
        baseTaxInvoiced: s.baseTaxInvoiced,
        discountPercent: s.discountPercent,
        discountAmount: s.discountAmount,
        baseDiscountAmount: s.baseDiscountAmount,
        discountInvoiced: s.discountInvoiced,
        baseDiscountInvoiced: s.baseDiscountInvoiced,
        amountRefunded: s.amountRefunded,
        baseAmountRefunded: s.baseAmountRefunded,
        rowTotal: s.rowTotal,
        baseRowTotal: s.baseRowTotal,
        rowInvoiced: s.rowInvoiced,
        baseRowInvoiced: s.baseRowInvoiced,
        rowWeight: s.rowWeight,
        baseTaxBeforeDiscount: s.baseTaxBeforeDiscount,
        taxBeforeDiscount: s.taxBeforeDiscount,
        extOrderItemId: s.extOrderItemId,
        lockedDoInvoice: s.lockedDoInvoice,
        lockedDoShip: s.lockedDoShip,
        priceInclTax: s.priceInclTax,
        basePriceInclTax: s.basePriceInclTax,
        rowTotalInclTax: s.rowTotalInclTax,
        baseRowTotalInclTax: s.baseRowTotalInclTax,
        hiddenTaxAmount: s.hiddenTaxAmount,
        baseHiddenTaxAmount: s.baseHiddenTaxAmount,
        hiddenTaxInvoiced: s.hiddenTaxInvoiced,
        baseHiddenTaxInvoiced: s.baseHiddenTaxInvoiced,
        hiddenTaxRefunded: s.hiddenTaxRefunded,
        baseHiddenTaxRefunded: s.baseHiddenTaxRefunded,
        isNominal: s.isNominal,
        taxCanceled: s.taxCanceled,
        hiddenTaxCanceled: s.hiddenTaxCanceled,
        taxRefunded: s.taxRefunded,
        baseTaxRefunded: s.baseTaxRefunded,
        discountRefunded: s.discountRefunded,
        baseDiscountRefunded: s.baseAmountRefunded,
        giftMessageId: s.giftMessageId,
        giftMessageAvailable: s.giftMessageAvailable,
        baseWeeeTaxAppliedAmount: s.baseWeeeTaxAppliedAmount,
        baseWeeeTaxAppliedRowAmnt: s.baseWeeeTaxAppliedRowAmnt,
        weeeTaxAppliedAmount: s.weeeTaxAppliedAmount,
        weeeTaxAppliedRowAmount: s.baseWeeeTaxAppliedRowAmnt,
        weeeTaxApplied: s.weeeTaxApplied,
        weeeTaxDisposition: s.weeeTaxDisposition,
        weeeTaxRowDisposition: s.weeeTaxRowDisposition,
        baseWeeeTaxDisposition: s.baseWeeeTaxDisposition,
        baseWeeeTaxRowDisposition: s.baseWeeeTaxRowDisposition,
        imageUrl: s.imageUrl,
        image: s.imageUrl,
        categoryId: s.categoryId,
        orderId: s.orderId,
      }));
    });

    return formArray;
  }




  review(product) {
    //  this.router.navigate([`review/${productId}`])
    this.commonService.productNavigaitionReview(product.value)
  }



  invoiceDownload() {
    // let entityId = this.activatedRoute.snapshot.params['entityId'];
    // this.orderService.downloadInvoice(entityId).subscribe(
    //   data => {
    //     download(data);
    //   }
    // )
    let DATA: any = document.getElementById('htmlData');

    DATA.style.display = 'block';
    this.init = true;
    html2canvas(DATA).then((canvas) => {
      // Define the dimensions for A4 size in pixels
      const a4Width = 595.28; // A4 width in points (210mm) converted to pixels (72 DPI)
      const a4Height = 841.89; // A4 height in points (297mm) converted to pixels (72 DPI)

      // Calculate the dimensions to maintain the aspect ratio
      let canvasWidth = canvas.width;
      let canvasHeight = canvas.height;
      let aspectRatio = canvasWidth / canvasHeight;

      let fileWidth = a4Width;
      let fileHeight = fileWidth / aspectRatio;

      if (fileHeight > a4Height) {
        fileHeight = a4Height;
        fileWidth = fileHeight * aspectRatio;
      }

      const FILEURI = canvas.toDataURL('image/png');
      let PDF = new jsPDF('p', 'mm', 'a4');
      let position = 0;

      // Convert dimensions to mm for jsPDF
      let fileWidthMm = fileWidth * 0.264583; // 1 px = 0.264583 mm
      let fileHeightMm = fileHeight * 0.264583;

      PDF.addImage(FILEURI, 'PNG', 0, position, fileWidthMm, fileHeightMm);

      let name = 'order-invoice-' + this.order.extOrderId + '.pdf';
      PDF.save(name);

      DATA.style.display = 'none';
    });
  }

  productShow(product) {

    this.commonService.productNavigationCart(product.value)

  }

  //tracking
  trackValues: any = [];
  getTracking() {
    this.trackingService.getTrackingInfo().subscribe(
      res => {
        this.trackValues = res

      }
    )
  }


  aramexShipping() {
    this.type = 'full'
    if (window.innerWidth > 768) {
      let dialogRef = this.dialog.open(TrackShipmentComponent, {
        width: '790px',
        data: {address:this.address,config:this.data, page: this.salesFlatShipment, track: this.trackValues, types: this.type, wareLat:this.warehouseLatitude, wareLong:this.warehouseLongitude }
      });
      dialogRef.disableClose = true;
      dialogRef.afterClosed().subscribe(result => {

      });
    }
    else {
      let dialogRef = this.dialog.open(TrackShipmentComponent, {
        minWidth: '100vw', height: '100vh',
        data: { address:this.address,config:this.data,page: this.salesFlatShipment, track: this.trackValues, types: this.type, wareLat:this.warehouseLatitude, wareLong:this.warehouseLongitude }
      });
      dialogRef.disableClose = true;
      dialogRef.afterClosed().subscribe(result => {


      });
    }

  }
  salesFlatShipment: any;
  eachTrackValue: any;
  type: string;
  trackEachStatus(i, j) {

    let entityId = this.activatedRoute.snapshot.params['entityId'];
    this.orderService.shippingForEachItem(entityId, i)
      .subscribe(
        (res: any) => {
          this.eachTrackValue = res;
          this.salesFlatShipment = res;
          this.aramexShipping();
          this.type = 'single'
        },
        error => {
        }
      )
  }

  shipRocketValues: any;
  getShipRocket() {
    this.trackingService.getShipRocket().subscribe(
      res => {
        this.shipRocketValues = res;

      }
    )
  }



  getImage(imageUrl: any): any {

    if (imageUrl == null) {

      return this.categoryPageImageLayout;
    }
    else if (imageUrl.includes('http')) {

      return imageUrl
    }
    else if (imageUrl.includes('medicineimages')) {
      let array = [];
      array = imageUrl.split('medicineimages');
      return environment.commonImageApiNew + 'medicineimages/' + array[1]

    } else if (imageUrl.includes('commonimages')) {
      let array = [];
      array = imageUrl.split('commonimages');

      return this.serverPath7 + 'commonimages/' + array[1]
    }
    else {
      return this.serverPath + imageUrl;
    }
  }

  @ViewChild('cancelOrderDialog') cancelOrderDialog: TemplateRef<any>;
  cancelOrder() {
    const dialogRef = this.dialog.open(this.cancelOrderDialog, {
      width: '450px',
      disableClose: true,

    });
    dialogRef.afterClosed().subscribe(result => {

      if (this.status == 'Change') {
        this.getOrderById();
      }

    });
  }




  cancel() {
    this.textCancel = "Processing";



    delete this.firstFormGroup.value['salesFlatInvoice'];

    delete this.firstFormGroup.value['salesFlatShipment'];

    delete this.firstFormGroup.value['salesFlatCreditmemo'];

    if (this.firstFormGroup.value.salesFlatOrderPayment.entityId == '') {
      delete this.firstFormGroup.value['salesFlatOrderPayment']
    }

    this.firstFormGroup.value.status = 'Cancelled';
    this.firstFormGroup.value.state = 'Cancelled';
    let salesFlatOrderStatusHistory = {
      'entityId': '',
      'isCustomerNotified': 1,
      'isVisibleOnFront': 0,
      'comment': '',
      'status': 'Cancelled',
      'entityName': 'Cancelled'
    }
    this.firstFormGroup.value.salesFlatOrderStatusHistory.push(salesFlatOrderStatusHistory)
    this.orderService.createOrder(this.firstFormGroup.value).subscribe(
      (response) => {
        if (response['status_code'] == Constant.RESPONSE_SUCCESS) {
          this.status = 'Change'
          this.close();
          this.textCancel = 'OK';
          this.snackBar.open(response['status_message'], '×', { panelClass: 'success', verticalPosition: 'bottom', duration: 3000 });
        } else {
          this.textCancel = 'OK';
          this.snackBar.open(response['status_message'], '×', { panelClass: 'error', verticalPosition: 'bottom', duration: 3000 });
        }

      },
    );
  }


  close() {
    this.dialog.closeAll();

  }

  getOrderStatus(status: any): any {
    this.orderstatusService.getOrderStateById(status).subscribe(
      res => {

        let orderstatus = res['label'];

        this.firstFormGroup.value.newStatus = orderstatus;

        this.firstFormGroup.patchValue(this.firstFormGroup.value)
        return orderstatus

      },
      error => {
        console.log("error", error);
        return status
      }
    )

  }

  @ViewChild('htmlData', { static: false }) htmlData: ElementRef;

  public serverPath1 = environment.serverAPI2 + "/api/core/download?fileName=logo/logo.png";

  pdfOptions = {
    value: {
      pageFormat: 'A4' // or 'A3', 'A2', etc.
    }
  };

  h2c: any = html2canvas;


  generate() {
    this.btndownload = 'Downloading ...';
    let DATA: any = document.getElementById('htmlData');
    DATA.style.display = 'block';
    this.h2c(DATA, {
      allowTaint: true,
      useCORS: true
    }).then((canvas) => {
      let fileWidth = 208;
      let fileHeight = (canvas.height * fileWidth) / canvas.width;
      const FILEURI = canvas.toDataURL('image/png');
      let PDF = new jsPDF('p', 'mm', 'a4');
      let position = 0;
      PDF.addImage(FILEURI, 'PNG', 0, position, fileWidth, fileHeight);

      let name = 'order-invoice-' + this.order.extOrderId + '.pdf';
      PDF.save(name);
      DATA.style.display = 'none';
      this.btndownload = 'Download';
    });
    ;
  }


  exportAllToPDF(pages: HTMLElement) {
    const doc = new jsPDF({
      unit: 'px',
      format: this.pdfOptions.value.pageFormat === 'A4' ? [595, 842] : [842, 1191]
    });

    doc.html(pages, {
      callback: (doc: jsPDF) => {
        doc.deletePage(doc.getNumberOfPages());
        doc.save('pdf-export');
      }
    });
  }


}


